function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React from 'react';
import { defaultStyles, dimensionsHelper, addPresetStyles } from 'pro-gallery-lib';
import ProGallery from './proGallery/proGallery';
import basePropTypes from './proGallery/propTypes';
import isEligibleForLeanGallery from './leanGallery/isEligible';
import LeanGallery from './leanGallery/leanGallery';

var BaseGallery = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(BaseGallery, _React$Component);

  function BaseGallery() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = BaseGallery.prototype;

  _proto.render = function render() {
    var domId = this.props.domId || 'default-dom-id';

    var _this$props = this.props,
        styles = _this$props.styles,
        options = _this$props.options,
        styleParams = _this$props.styleParams,
        eventsListener = _this$props.eventsListener,
        otherProps = _objectWithoutPropertiesLoose(_this$props, ["styles", "options", "styleParams", "eventsListener"]);

    var _eventsListener = function _eventsListener() {
      return typeof eventsListener === 'function' && eventsListener.apply(void 0, arguments);
    };

    var _styles = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, defaultStyles), options), styles), styleParams);

    var galleryProps = _objectSpread(_objectSpread({}, otherProps), {}, {
      styles: _styles,
      eventsListener: _eventsListener,
      domId: domId
    });

    var shouldRenderLean = isEligibleForLeanGallery(galleryProps);
    var key = [domId, shouldRenderLean].join('_');

    if (this.props.useBlueprints) {//
    } else {
      dimensionsHelper.updateParams({
        domId: galleryProps.domId,
        container: galleryProps.container,
        styles: galleryProps.styles
      });
      var _galleryProps$styles = galleryProps.styles,
          galleryType = _galleryProps$styles.galleryType,
          galleryLayout = _galleryProps$styles.galleryLayout;

      if (galleryType === undefined || galleryLayout !== undefined) {
        galleryProps = _objectSpread(_objectSpread({}, galleryProps), {}, {
          styles: addPresetStyles(galleryProps.styles)
        });
      }
    }

    var GalleryComponent = ProGallery;

    if (shouldRenderLean) {
      GalleryComponent = LeanGallery;
    }

    return /*#__PURE__*/React.createElement(GalleryComponent, _extends({
      key: key
    }, galleryProps));
  };

  return BaseGallery;
}(React.Component);

export { BaseGallery as default };